import { z } from "zod";
import { chartInsightSchema } from "./chart-insight.js";
import { chartRecommendationSchema } from "./chart-recommendation.js";

export const aiChatRowSchema = z.record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null()]));

export const aiChatResponseSchema = z.object({
	prompt: z.string(),
	sql_query: z.string().nullable(),
	rows: z.array(aiChatRowSchema),
	row_count: z.number().int().nonnegative(),
	conversational_response: z.string(),
	chart_recommendation: chartRecommendationSchema.nullable(),
	insights: z.array(chartInsightSchema),
	execution_time_ms: z.number().int().nonnegative(),
	model: z.string(),
});

export type AIChatRow = z.infer<typeof aiChatRowSchema>;
export type AIChatResponse = z.infer<typeof aiChatResponseSchema>;
